import compareAsc from 'date-fns/compareAsc';
import subYears from 'date-fns/subYears';
import { validateNotEmpty } from '@alfa-bank/site-form-helpers/validation/not-empty';
import { composeValidators, validate } from '@alfa-bank/site-form-helpers/validation/utils';

import { DEFAULT_DATE_FAIL, MIN_YEAR } from './config';

/** Вычисляет, является ли год високосным */
const isLeapYear = (year: number) => (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;

const checkYear = (value: number) => value >= MIN_YEAR;

const checkMonth = (value: number) => value > 0 && value <= 12;

const checkDay = (dateArray: number[]) => {
    const [day, month, year] = dateArray;
    let daysInMonth: number;

    // Проверяем февраль
    if (month === 2) {
        daysInMonth = isLeapYear(year) ? 29 : 28;
    } else {
        // Проверяем месяцы, где 30 дней
        daysInMonth = [4, 6, 9, 11].includes(month) ? 30 : 31;
    }

    return day > 0 && day <= daysInMonth;
};

export const checkAgeLimit = (date: Date | number, ageLimit: number): boolean => {
    const ageLimitDate = subYears(new Date(), ageLimit);
    const isValid = compareAsc(ageLimitDate, date);

    return isValid !== -1;
};

export const checkAgeCeil = (date: Date | number, ageCeil: number): boolean => {
    const ageCeilDate = subYears(new Date(), ageCeil);
    const isValid = compareAsc(date, ageCeilDate);

    return isValid !== -1;
};

export const isValidDate = (date = '', ageLimit?: number, ageCeil?: number) => {
    const dateArray = date.split('.');

    if (dateArray.length !== 3 || !/^\d{4}$/.test(dateArray[2])) {
        return false;
    }

    const numberDates = dateArray.map(Number);

    const isValidYear = checkYear(numberDates[2]);
    const isValidMonth = checkMonth(numberDates[1]);
    const isValidDay = checkDay(numberDates);

    const currentDate = new Date().getTime();
    const inputDate = new Date(numberDates[2], numberDates[1] - 1, numberDates[0]).getTime();
    const checkValidDate = isValidDay && isValidMonth && isValidYear && currentDate >= inputDate;

    if (ageLimit) {
        const isValidAgeLimit = checkAgeLimit(inputDate, ageLimit);

        if (!isValidAgeLimit) {
            return false;
        }
    }

    if (ageCeil) {
        const isValidAgeCeil = checkAgeCeil(inputDate, ageCeil);

        if (!isValidAgeCeil) {
            return false;
        }
    }

    return checkValidDate;
};

export const validateBirthdayValue =
    (customMessage?: string, ageLimit?: number, ageCeil?: number) => (value?: string) =>
        value
            ? validate(isValidDate(value, ageLimit, ageCeil), DEFAULT_DATE_FAIL, customMessage)
            : undefined;

// TODO можно удалить хелпер если спустя время так и не пригодится
export const validateBirthday = (
    message?: string,
    ageLimit?: number,
    ageCeil?: number,
    isRequired?: boolean
) => {
    const validators = isRequired
        ? [validateNotEmpty(), validateBirthdayValue(message, ageLimit, ageCeil)]
        : [validateBirthdayValue(message, ageLimit, ageCeil)];

    return composeValidators(...validators);
};
